import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Order, { OrderItem, OrderBundleSurchargeItem, OrderSurchargeItem, OrderItemStatus, OrderItemLock, OrderUpdateStatus, RedeemTourOrder, Customer, SmsHistory, FixChargeItem } from './../models/Order';
import { omit } from 'lodash';
import { getContentLanguage } from '../utils/commonUtils';
import moment from 'moment';

export function getOrders(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_LIST,
        params: params,
        parser: ordersDataParser,
    }).get();
}

export function pushFixedCharge(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_PUSH_FIXED_CHARGE+`/${params.orderId}`,
        
    }).post();
}

export function getOrderDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_DETAIL,
        endpointParams: { id },
        parser: (data) => new Order(data.data),
    }).get();
}
export function getOrderDetailGolf(vptOrderId) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.ORDER_DETAIL_GOLF,
        endpointParams: { vptOrderId },
        parser: (data) => data.data,
    }).get();
}

export function getOrderItems(orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_DETAIL_ITEM,
        endpointParams: { id: orderId },
        parser: (data) => new OrderItem(data.data),
    }).get();
}

export function exportExcel(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXPORT_EXCEL,
        isDownload: true,
        params: params,
    }).get();
}

export function exportSkuExcel(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXPORT_SKU_EXCEL,
        isDownload: true,
        params: params,
    }).get();
}

export function exportSkuSaleDetailExcel(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL,
        isDownload: true,
        params: params,
    }).get();
}

export function exportHotelSaleDetailExcel(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL,
        isDownload: true,
        params: params,
    }).get();
}

export function exportAccessTrade(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXPORT_ACCESS_TRADE,
        isDownload: true,
        params: params,
    }).get();
}

export function getAffiliateSources() {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_AFFILIATE_SOURCES,
        parser: data => data.data || [],
    }).get();
}

export function exportSaleOrder(saleOrder) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXPORT_SALE_ORDER,
        headers: {
            'accept-language': getContentLanguage() === 'all' ? 'vi-VN' : getContentLanguage()
        }
    }).post(saleOrder.export());
}

export function exportTourSaleOrder(tourSaleOrder) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXPORT_TOUR_SALE_ORDER,
        headers: {
            'accept-language': getContentLanguage() === 'all' ? 'vi-VN' : getContentLanguage()
        }
    }).post(tourSaleOrder);
}

export function exportVoucher(orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXPORT_VOUCHER,
        isDownload: true,
        endpointParams: { id: orderId }
    }).get();
}

export function resendEmail(orderId, timezoneOffset = new Date().getTimezoneOffset()) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_RESEND_EMAIL,
        params: { timezoneOffset },
        endpointParams: { id: orderId }
    }).get();
}

export function updateOrder(order) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_UPDATE,
    }).put(order.export());
}

export function updateOrderAccountant(order) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_ACCOUNTANT,
        endpointParams: {orderId: order?.id, accountantStatus: order?.accountantStatus},
    }).put();
}

export function updateFlight(flight) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.ORDER_FLIGHT_UPDATE,
    }).put(flight.export());
}

export function updateOrderInvoice(orderInvoice) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_UPDATE_INVOICE,
    }).put(orderInvoice.export());
}

export function sendEmailTemplate(orderId, emailId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SEND_EMAIL_TEMPLATE,
        endpointParams: { id: orderId, email_id: emailId }
    }).get();
}


export function getOrderSurchargeItems(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SURCHARGE_ITEMS,
        params: params,
        parser: surchargeDataParser,
    }).get();
}
export function bundleOrderCreateSurcharge(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SURCHARGE_ITEMS,
    }).post(params);
}

export function bundleOrderCancelSurcharge(params) {
  return new ApiService({
      baseURL: Config.API_ORDER,
      endpoint: `${Urls.ORDER_SURCHARGE_ITEMS}/${params.id}?ftCode=${params.ftCode}`,
  }).delete();
}

export function getSurchargeDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SURCHARGE_GET_DETAIL,
        endpointParams: { id },
        parser: (data) => new OrderSurchargeItem(data.data),
    }).get();
}

export function createSurchargeDetail(surcharge) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SURCHARGE_DETAIL_ACTION,
        parser: (data) => new OrderSurchargeItem(data.surcharge),
    }).post(surcharge.export());
}

export function updateSurchargeDetail(surcharge) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SURCHARGE_DETAIL_ACTION,
        parser: (data) => new OrderSurchargeItem(data.surcharge),
    }).put(surcharge.export());
}

export function deleteSurchargeDetail(surchargeId, ftCode, isBackStock) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: `${Urls.ORDER_SURCHARGE_ITEMS}/${surchargeId}?ftCode=${ftCode}&isBackStock=${isBackStock || false}`
    }).delete();
}

export function updateStatusOrderItem(item) {
    const data = new OrderItemStatus(item)
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_ITEM_CHANGE_STATUS,
    }).put(data.export());
}

export function lockOrderItem(item) {
    const data = new OrderItemLock(item)
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_ITEM_LOCK,
    }).put(data.export());
}

export function recommitTourOrder(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_TOUR_RECOMMIT,
        endpointParams: { id }
    }).put();
}

export function retryCiapsBooking(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_RETRY_CIAPS_BOOKING,
        endpointParams: { id }
    }).post();
}

export function updateOrderStatus(item) {
    const orderStatus = new OrderUpdateStatus(item)
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_CHANGE_STATUS,
    }).put(orderStatus.export());
}

export function checkDataRedeem(data) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_CHECK_REDEEM,
        parser: (redeemData) => new RedeemTourOrder({ ...data, ...redeemData }),
    }).post(data.exportCheck());
}

export function redeemItem(data, index) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_REDEEM,
    }).put(data.exportRedeem(index));
}

export function getTransportations(propertyId, confirmationNumber) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.GET_TRANSPORTATIONS,
        params: { confirmationNumber },
        endpointParams: { propertyId }
    }).get();
}

export function getAirline() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRLINE_ALL
    }).get();
}

export function recommitHotelBundle(data) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_RECOMMIT_HOTEL_BUNDLE
    }).put(data);
}

export function getAirport() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_ALL,
        headers: {
            'accept-language': 'vi-VN'
        }
    }).get();
}

export function getRoutes(propertyId) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.GET_ROUTES,
        endpointParams: { propertyId }
    }).get();
}

export function getVehicleTypes(routeId, propertyId) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.GET_VEHICLE_TYPES,
        endpointParams: { propertyId, routeId }
    }).get();
}

export function getVehicle(vehicleTypeId, propertyId) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.GET_VEHICLE,
        endpointParams: { vehicleTypeId, propertyId }
    }).get();
}

export function changeRateCode(change) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_CHANGE_RATE_CODE,
    }).put(change);
}

function ordersDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new Order(item))
    }
}

function surchargeDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new OrderBundleSurchargeItem(item))
    }
}

export function getVinwonderCustomers(orderId) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.VINWONDER_CUSTOMERS_LIST,
        endpointParams: { orderId: orderId },
        parser: (data) => {
            return (data?.data || []).map(item => new Customer(item))
        },
    }).get();
}

export function getSmsHistories(orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.SMS_HISTORIES_LIST,
        endpointParams: { orderId: orderId },
        parser: (data) => {
            return (data?.result || []).map(item => new SmsHistory(item))
        },
    }).get();
}

export function resendSms(id, orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.SMS_RESEND,
        endpointParams: { id, orderId },
    }).post().catch((error) => ({ errors: error?.errors }));
}

export function updateOrderProfile(profile) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.UPDATE_ORDER_PROFILE,
    }).put(profile.export())
}

export function resendFixCharge (id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXCHARGE_RESEND
    }).post(id)
}

export function repushAffiliate (orderId, status) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: `${Urls.ORDER_REPUSH_AFFILIATE}/${orderId}?status=${status}`,
    }).post();
}

export function fixchargeOrder(orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_EXCHARGE,
        endpointParams: {orderId: orderId},
        parser: (data) => {
            return (data?.data?.fixCharges || []).map(item => new FixChargeItem(item))
        },
    }).get();
}

export function createFlightTracking(data) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_TRACKING,
    }).post(exportFlightTracking(data))
}

export function updateFlightTracking(data) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_TRACKING_DETAIL,
        endpointParams: {id: data?.id}
    }).put(exportFlightTracking(data))
}

export function getDetailFlightTracking(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_TRACKING_DETAIL,
        endpointParams: {id}
    }).get()
}

export function deleteFlightTracking(data) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_TRACKING_DETAIL,
        endpointParams: {id: data?.id},
        params: {itemVariantId: data?.itemVariantId}
    }).delete()
}

export function getFlightTrackingOrder(orderId) {

    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_TRACKING_ORDER,
        endpointParams: {orderId}
    }).get()
}

const exportFlightTracking = (data) => {
    return {
        itemVariantId: data.itemVariantId,
        orderId: data.orderId,
        orderCode: data.orderCode,
        departureAirportCode: data.departureAirportCode,
        arrivalAirportCode: data.arrivalAirportCode,
        airlineCode: data.airlineCode,
        airlineNumber: data.airlineNumber,
        // departureTime: moment(data.departureDate + ' ' + data.departureTime, 'YYYY/MM/DD HH:mm').format()
        departureTime: `${data.departureDate}T${data.departureTime}:00`
    }
}
export function getPointHistories(orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.GET_POINT_HISTORIES,
        endpointParams: { id: orderId },
    }).get();
}

export function refundOrderPoint(orderId) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.REFUND_ORDER_POINT,
        endpointParams: {id: orderId},
    }).post();
}
